var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChipStatus, } from '../status-chip/models/ChipStatus';
import StatusChip from '../status-chip/status-chip';
import * as styles from './header-slider.styles';
import { Carousel } from 'react-responsive-carousel';
import { useWindowSize } from '@reach/window-size';
import { classNames } from '../../utils';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
var MARGIN = 32;
export var HeaderSlider = function (_a) {
    var slides = _a.slides, infiniteLoop = _a.infiniteLoop, autoPlay = _a.autoPlay, transitionTime = _a.transitionTime, className = _a.className, cardClassName = _a.cardClassName, isSetupComponent = _a.isSetupComponent;
    var width = useWindowSize().width;
    var getChipStatusText = function (status) {
        switch (status) {
            case 1:
                return 'Available now';
            case 2:
                return 'Comming soon';
            default:
                return '';
        }
    };
    var getChipStatusColourPalette = function (status) {
        switch (status) {
            case ChipStatus.Available:
                return {
                    textColour: 'white',
                    borderColour: 'successMain',
                    backgroundColour: 'successMain',
                };
            case ChipStatus.ComingSoon:
            default:
                return {
                    textColour: 'alertMain',
                    borderColour: 'alertMain',
                    backgroundColour: 'white',
                };
        }
    };
    var renderIndicator = function (onClickHandler, isSelected, index, label) {
        if (isSelected) {
            return (_jsx("li", { className: styles.activePaginationItem, "aria-label": "Selected: ".concat(label, " ").concat(index + 1), title: "Selected: ".concat(label, " ").concat(index + 1) }));
        }
        return (_jsx("li", { className: styles.paginationItem, onClick: onClickHandler, onKeyDown: onClickHandler, value: index, role: "button", tabIndex: 0, title: "".concat(label, " ").concat(index + 1), "aria-label": "".concat(label, " ").concat(index + 1) }, index));
    };
    return (_jsx(Carousel, __assign({ className: className, infiniteLoop: infiniteLoop, autoPlay: autoPlay, renderIndicator: renderIndicator, showIndicators: isSetupComponent ? false : true, showThumbs: false, showStatus: false, showArrows: false }, (transitionTime && { transitionTime: transitionTime }), { children: slides.map(function (slide, idx) {
            var palette = getChipStatusColourPalette(slide.status);
            return (_jsx("div", __assign({ className: classNames(styles.slide, cardClassName) }, { children: _jsxs("div", __assign({ "data-testid": "header-slide-".concat(idx), className: styles.card, style: { width: width < 768 ? width - MARGIN : '100%' } }, { children: [_jsxs("div", __assign({ className: !(slide === null || slide === void 0 ? void 0 : slide.title) && !(slide === null || slide === void 0 ? void 0 : slide.text)
                                ? styles.imageWrapperWithNoText
                                : styles.imageWrapper }, { children: [_jsx("img", { src: slide.image, className: styles.cardBanner }), (slide === null || slide === void 0 ? void 0 : slide.overlayText) && (_jsx("div", __assign({ className: styles.imageOverlayText }, { children: slide.overlayText })))] })), ((slide === null || slide === void 0 ? void 0 : slide.title) || (slide === null || slide === void 0 ? void 0 : slide.text)) && (_jsxs("div", __assign({ className: styles.cardInformation }, { children: [slide.status && (_jsx(StatusChip, { backgroundColour: palette.backgroundColour, textColour: palette.textColour, borderColour: palette.borderColour, text: getChipStatusText(slide.status), className: styles.statusChip })), (slide === null || slide === void 0 ? void 0 : slide.title) && (_jsx("div", __assign({ className: styles.cardTitle }, { children: slide.title }))), (slide === null || slide === void 0 ? void 0 : slide.text) && (_jsx("div", __assign({ className: styles.cardText }, { children: slide.text })))] })))] })) }), "header-slide-".concat(idx)));
        }) })));
};
export default HeaderSlider;
//# sourceMappingURL=header-slider.js.map